import React, {Component} from 'react';
import { Link } from 'react-router-dom'
import './NavbarDropdown.css';


export default class NavbarNonDropdown extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="navbar_dropdown_container" onMouseEnter={this.handleMouseHover} onMouseLeave={this.handleMouseHover}>
			<Link to={this.props.data.childLink}>
				<div className="navbar_dropdown_header">
					<div className="navbar_dropdown_header_title">{this.props.headerTitle}</div>
				</div>
			</Link>
			</div>
		)
	}
};
